import React, { useState } from 'react';
import api from '../api';
import { Pilules, TYPES, Icone, remplacer, messageErreur } from './commun';

// Trois champs suffisent : nom, type, ville. Le reste se complète au fil des échanges.
export default function Nouveau({ utilisateur, referentiel }) {
  const [f, setF] = useState({ nom: '', type: '', ville: '', telephone: '', contact_nom: '', email: '' });
  const [societe, setSociete] = useState(utilisateur.societe_id ? String(utilisateur.societe_id) : (referentiel?.societes.length === 1 ? String(referentiel.societes[0].id) : ''));
  const [erreur, setErreur] = useState('');
  const [existant, setExistant] = useState(null);
  const [envoi, setEnvoi] = useState(false);
  const maj = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const creer = async (noter) => {
    setErreur(''); setExistant(null);
    if (!f.nom.trim() || !f.type || !f.ville.trim()) { setErreur('Nom, type et ville sont obligatoires.'); return; }
    if (!utilisateur.societe_id && !societe) { setErreur('Choisissez la société.'); return; }
    setEnvoi(true);
    try {
      const { data } = await api.post('/commercial/comptes', { ...f, societe_id: societe || undefined });
      remplacer(`#/compte/${data.compte.id}${noter ? '?noter=1' : ''}`);
    } catch (e) {
      setErreur(messageErreur(e, 'Création impossible.'));
      if (e.response?.data?.existant_id) setExistant(e.response.data.existant_id);
    } finally { setEnvoi(false); }
  };

  return (
    <form className="nouveau" onSubmit={(e) => { e.preventDefault(); creer(true); }}>
      <button type="button" className="retour-mobile" onClick={() => window.history.back()}><Icone.Retour /> Retour</button>
      <h1>Nouveau prospect</h1>
      <div className="carte nouveau-carte">
        <label className="etiquette" htmlFor="n-nom">Nom de l'établissement *</label>
        <input id="n-nom" value={f.nom} onChange={maj('nom')} autoFocus autoComplete="off" placeholder="Ex. : Cave du Vieux Port" />

        <span className="etiquette">Type *</span>
        <Pilules etiquette="Type de client" options={TYPES.filter((t) => t.cle !== 'autre').concat([{ cle: 'autre', libelle: 'Autre' }])}
          valeur={f.type} onChange={(v) => setF({ ...f, type: v })} className="pilules-types" />

        <label className="etiquette" htmlFor="n-ville">Ville *</label>
        <input id="n-ville" value={f.ville} onChange={maj('ville')} autoComplete="address-level2" />

        {!utilisateur.societe_id && (referentiel?.societes.length || 0) > 1 && (
          <>
            <span className="etiquette">Société *</span>
            <Pilules etiquette="Société" valeur={societe} onChange={setSociete}
              options={referentiel.societes.map((s) => ({ cle: String(s.id), libelle: s.nom }))} />
          </>
        )}

        <span className="etiquette discret">Facultatif, à compléter plus tard</span>
        <input value={f.telephone} onChange={maj('telephone')} type="tel" placeholder="Téléphone" aria-label="Téléphone" autoComplete="off" />
        <input value={f.contact_nom} onChange={maj('contact_nom')} placeholder="Nom du contact" aria-label="Nom du contact" autoComplete="off" />
        <input value={f.email} onChange={maj('email')} type="email" placeholder="E-mail" aria-label="E-mail" autoComplete="off" />
        <p className="aide">Trois champs suffisent pour créer le compte. Le reste se complète au fil des échanges, sur PC ou sur le téléphone.</p>
      </div>
      {erreur && <div className="erreur">{erreur} {existant && <a href={`#/compte/${existant}`}>Ouvrir le compte existant</a>}</div>}
      <div className="nouveau-actions">
        <button type="submit" className="bouton-grand" disabled={envoi}>Créer et noter un premier échange</button>
        <button type="button" className="lien" disabled={envoi} onClick={() => creer(false)}>Créer seulement</button>
      </div>
    </form>
  );
}
